export const UserDrop_list = [
  {id: 1, title: 'Профиль', path: '/profile'},
  {id: 2, title: 'Сохраненные', path: '/saved'},
]